import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormValidationDirective } from './form-validation.directive';
import { MessagesComponent } from './messages.component';
import { FormControlDirective } from './form-control.directive';
import { MatInputModule } from '@angular/material/input';


const components = [
  FormControlDirective,
  FormValidationDirective,
  MessagesComponent,
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    MatInputModule
  ],
})
export class BcrowValidatorModule { }
